import { styled } from '@mui/material/styles';
import { Switch as MuiSwitch, Box } from "@mui/material";

export const SwitchContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  columnGap: theme.space._300,

  fontFamily: theme.fonts.default,
  fontWeight: theme.fontWeights.regular,
  lineHeight: theme.lineHeights.short,

  ".disabled": {
    opacity: theme.opacity.medium,
  },
}));

export const CustomSwitch = styled(MuiSwitch)(({ theme }) => ({
  padding: 0,
  
  ".MuiSwitch-track": {
    borderRadius: "100px",
    border: `1px solid ${theme.colors["neutral.900"]}`,
    backgroundColor: theme.colors['neutral.200'],
    opacity: theme.opacity.default
  },

  ".MuiSwitch-switchBase": {
    padding: 0,
    bottom: 0,
    left: "2px",

    "&.Mui-checked" : {
      color: theme.colors.white,
    },

    "&.Mui-checked+.MuiSwitch-track": {
      opacity: theme.opacity.default,
      backgroundColor: theme.colors["neutral.900"],
    },

    ".MuiSwitch-thumb": {
      width: "18px",
      height: "18px",
      border: `1px solid ${theme.colors["neutral.900"]}`,
      boxShadow: "none",
    },

    "&.Mui-disabled": {
      color: theme.colors.white,
      opacity: theme.opacity.light,
      cursor: "not-allowed",
      pointerEvents: "auto"
    },
  },
}));